import interLatin400 from "@fontsource/inter/files/inter-latin-400-normal.woff2?url";
import interLatin600 from "@fontsource/inter/files/inter-latin-600-normal.woff2?url";

function preloadFont(href: string) {
  if (document.head.querySelector(`link[rel="preload"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/woff2";
  link.href = href;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

/** Kritik Inter latin — JS’ten hemen sonra (CSS keşfinden önce); latin-ext idle */
export function preloadCriticalFonts() {
  preloadFont(interLatin400);
  preloadFont(interLatin600);
}
